import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon }          from '@fortawesome/react-fontawesome'
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import { XYPlot,
          Crosshair,
          DiscreteColorLegend,
          FlexibleWidthXYPlot,
          HorizontalGridLines,
          LineSeries,
          LineMarkSeries,
          VerticalGridLines,
          SearchableDiscreteColorLegend,
          XAxis,
          YAxis }        from 'react-vis';

const axisProps = {
    tickSizeInner: 0,
    style: {line: {stroke: '#939393', strokeWidth: '1px'}}
};

const upper_chest_color      = "#c22a2a";
const lower_chest_color      = "#6621c4";
const abdomen_color          = "#2e78e7";
const waist_color            = "#bf56fc";
const hip_color              = "#56e7fc";
const thigh_right_color      = "#fc9856";
const thigh_left_color       = "#fc56a0";
const calf_right_color       = "#c91bde";
const calf_left_color        = "#1bc9de";
const arm_right_color        = "#dea91b";
const arm_left_color         = "#3da211";
const arm_flexed_right_color = "#666666";

const arm_flexed_left_color  = "#e63a4e";
const forearm_right_color    = "#b5d714";
const forearm_left_color     = "#1454d7";
const neck_color             = "#eca316";
const shoulder_color         = "#1ec022";

const GIRTH_LEGEND = [
    {title: 'All',  data: "all_data", color: "#000", strokeWidth: 14},
    {title: 'Upper Chest',  data: "upper_chest_data", color: upper_chest_color, strokeWidth: 14},
    {title: 'Lower Chest', data: "lower_chest_data", color: lower_chest_color, strokeWidth: 14 },
    {title: 'Abdomen', data: "abdomen_data", color: abdomen_color, strokeWidth: 14 },
    {title: 'Waist', data: "waist_data", color: waist_color, strokeWidth: 14 },
    {title: 'Hip', data: "hip_data", color: hip_color, strokeWidth: 14 },
    {title: 'Right Thigh', data: "thigh_right_data", color: thigh_right_color, strokeWidth: 14 },
    {title: 'Left Thigh', data: "thigh_left_data", color: thigh_left_color, strokeWidth: 14 },
    {title: 'Right Calf', data: "calf_right_data", color: calf_right_color, strokeWidth: 14 },
    {title: 'Left Calf', data: "calf_left_data", color: calf_left_color, strokeWidth: 14 },
];

const GIRTH_LEGEND2 = [
    {title: 'Right Arm', data: "arm_right_data", color: arm_right_color, strokeWidth: 14 },
    {title: 'Left Arm', data: "arm_left_data", color: arm_left_color, strokeWidth: 14 },
    {title: 'Right Arm Flexed ', data: "arm_flexed_right_data", color: arm_flexed_right_color, strokeWidth: 14 },
    {title: 'Left Arm Flexed', data: "arm_flexed_left_data", color: arm_flexed_left_color, strokeWidth: 14 },
    {title: 'Right Forearm ', data: "forearm_right_data", color: forearm_right_color, strokeWidth: 14 },
    {title: 'Left Forearm', data: "forearm_left_data", color: forearm_left_color, strokeWidth: 14 },
    {title: 'Neck', data: "neck_data", color: neck_color, strokeWidth: 14 },
    {title: 'Shoulder', data: "shoulder_data", color: shoulder_color, strokeWidth: 14 },
];

var upper_chest_data      = [];
var lower_chest_data      = [];
var abdomen_data          = [];
var waist_data            = [];
var hip_data              = [];
var thigh_right_data      = [];
var thigh_left_data       = [];
var calf_right_data       = [];
var calf_left_data        = [];
var arm_right_data        = [];
var arm_left_data         = [];
var arm_flexed_right_data = [];
var arm_flexed_left_data  = [];
var forearm_right_data    = [];
var forearm_left_data     = [];
var neck_data             = [];
var shoulder_data         = [];

var legend1_title  = "Upper Chest";
var legend2_title  = "Lower Chest";
var legend3_title  = "Abdomen";
var legend4_title  = "waist";
var legend5_title  = "hip";
var legend6_title  = "Right Thigh";
var legend7_title  = "Left Thigh";
var legend8_title  = "Right Calf";
var legend9_title  = "Left Calf";
var legend10_title = "Right Arm";
var legend11_title = "Left Arm";
var legend12_title = "Flexed Right Arm";
var legend13_title = "Flexed Left Arm";
var legend14_title = "Right Forearm";
var legend15_title = "Left Forearm";
var legend16_title = "Neck";
var legend17_title = "Shoulder";

export default class AssessGirth extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false,
            title:     "Girth Assessment",
            max_y_val: 0,
            min_y_val: 0,
            all_data: true,
            crosshairPreValues:      [],
        }
    }

    componentDidMount() {
        try {
            this.getClientData();
        } catch (e) {
            alert(e);
        }
    }

    resetDataVals () {
        upper_chest_data      = [];
        lower_chest_data      = [];
        abdomen_data          = [];
        waist_data            = [];
        hip_data              = [];
        thigh_right_data      = [];
        thigh_left_data       = [];
        calf_right_data       = [];
        calf_left_data        = [];
        arm_right_data        = [];
        arm_left_data         = [];
        arm_flexed_right_data = [];
        arm_flexed_left_data  = [];
        forearm_right_data    = [];
        forearm_left_data     = [];
        neck_data             = [];
        shoulder_data         = [];
    }

    getClientData = async () => {
        this.setState({
            loadingData: "Loading member data ... "
        })

        const results  = this.props.resultsGirth;

        var asessInbodyChartData = [];
        var max_yaxis_val        = [];

        // Reset all vals in case someone clicks "All" multiple times; we don't want multiple duplicate vals
        this.resetDataVals();

        if(results) {
            var data            = results.data.girth;
            var ctr = 0;
            var max_array = [];
            ////  BEGIN: BUILD OUT GRAPH DATA  ////
            for(var key in data) {
                var upper_chest      = data[key].upper_chest;
                var lower_chest      = data[key].lower_chest
                var abdomen          = data[key].abdomen;
                var waist            = data[key].waist;
                var hip              = data[key].hip;
                var thigh_right      = data[key].thigh_right;
                var thigh_left       = data[key].thigh_left;
                var calf_right       = data[key].calf_right;
                var calf_left        = data[key].calf_left;
                var arm_right        = data[key].arm_right;
                var arm_left         = data[key].arm_left;
                var arm_flexed_right = data[key].arm_flexed_right;
                var arm_flexed_left  = data[key].arm_flexed_left;
                var forearm_right    = data[key].forearm_right;
                var forearm_left     = data[key].forearm_left;
                var neck             = data[key].neck;
                var shoulder         = data[key].shoulder;
                var date_created     = data[key].date_created;
                var date             = (new Date(date_created)).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' })

                upper_chest_data.push({"x": date, "y": upper_chest});
                lower_chest_data.push({"x": date, "y": lower_chest});
                abdomen_data.push({"x": date, "y": abdomen});
                waist_data.push({"x": date, "y": waist});
                hip_data.push({"x": date, "y": hip});
                thigh_right_data.push({"x": date, "y": thigh_right});
                thigh_left_data.push({"x": date, "y": thigh_left});
                calf_right_data.push({"x": date, "y": calf_right});
                calf_left_data.push({"x": date, "y": calf_left});
                arm_right_data.push({"x": date, "y": arm_right});
                arm_left_data.push({"x": date, "y": arm_left});
                arm_flexed_right_data.push({"x": date, "y": arm_flexed_right});
                arm_flexed_left_data.push({"x": date, "y": arm_flexed_left});
                forearm_right_data.push({"x": date, "y": forearm_right});
                forearm_left_data.push({"x": date, "y": forearm_left});
                neck_data.push({"x": date, "y": neck});
                shoulder_data.push({"x": date, "y": shoulder});
                // Get Max Value of All Data points and then filter out the highest value to use in the y-axis //
                max_array.push(upper_chest, lower_chest, abdomen, waist, hip, thigh_right, thigh_left, calf_right, calf_left, arm_right, arm_left, arm_flexed_right, arm_flexed_left, forearm_right, forearm_left, neck, shoulder)
            }

            var max_y_val = Math.max(...max_array) + 35;

            this.setState({
                report_data: data.length,
                all_data: true,
                arm_left_data: arm_left_data,
                arm_flexed_right_data: arm_flexed_right_data,
                upper_chest_data: upper_chest_data,
                lower_chest_data: lower_chest_data,
                abdomen_data: abdomen_data,
                waist_data: waist_data,
                hip_data: hip_data,
                thigh_right_data: thigh_right_data,
                thigh_left_data: thigh_left_data,
                calf_right_data: calf_right_data,
                calf_left_data: calf_left_data,
                arm_right_data: arm_right_data,
                arm_flexed_left_data:arm_flexed_left_data,
                forearm_right_data: forearm_right_data,
                forearm_left_data: forearm_left_data,
                neck_data: neck_data,
                shoulder_data: shoulder_data,
                max_y_val: max_y_val,
                min_y_val: 0 // reset min y val
            })
        } else {
            //this.msgDataLoaded();
        }
    }

    onMouseLeavePreWorkout = () =>{
        this.setState({crosshairPreValues: []});
    }

    ////   Tooltip Hover   ////
    onNearestXPreWorkout = (value, {index}) => {
        var x   = upper_chest_data[index].y;
        var x2  = upper_chest_data[index].x;
        var y1  = lower_chest_data[index].y;
        var y2  = abdomen_data[index].y;
        var y3  = waist_data[index].y;
        var y4  = hip_data[index].y;
        var y5  = thigh_right_data[index].y;
        var y6  = thigh_left_data[index].y;
        var y7  = calf_right_data[index].y;
        var y8  = calf_left_data[index].y;
        var y9  = arm_right_data[index].y;
        var y10 = arm_left_data[index].y;
        var y11 = arm_flexed_right_data[index].y;
        var y12 = arm_flexed_left_data[index].y;
        var y13 = forearm_right_data[index].y;
        var y14 = forearm_left_data[index].y;
        var y15 = neck_data[index].y;
        var y16 = shoulder_data[index].y;

        this.setState({
                        crosshairPreValues: [{x: x2, y: y1}],
                        crossHairX:  x,
                        crossHairY1: y1,
                        crossHairY2: y2,
                        crossHairY3: y3,
                        crossHairY4: y4,
                        crossHairY5: y5,
                        crossHairY6: y6,
                        crossHairY7: y7,
                        crossHairY8: y8,
                        crossHairY9: y9,
                        crossHairY10: y10,
                        crossHairY11: y11,
                        crossHairY12: y12,
                        crossHairY13: y13,
                        crossHairY14: y14,
                        crossHairY15: y15,
                        crossHairY16: y16,
                      });
    };

    getMaxYAxisVals (data) {
        var arr = []
        var data2 = eval(data); // get actual vals of array

        for(var key in data2)
            arr.push(data2[key].y);

        var max_y_val = Math.max(...arr) + 15;
        var min_y_val = Math.min(...arr) - 15;

        // Don't let min_y_val go below 0
        if(min_y_val < 0) min_y_val = 0;

        var maxMinObj = {};
        maxMinObj.max_y_val = max_y_val;
        maxMinObj.min_y_val = min_y_val;

        return maxMinObj;
    }

    handleLegendClick = item => {
        var data = item.data;
        var dataset;

        if(data === "all_data")
            this.setState({
                all_data: false
            }, () => {
                this.getClientData();
            });
        else {
            if(data === "upper_chest_data")             dataset = {"upper_chest_data":upper_chest_data};
            else if(data === "lower_chest_data")        dataset = {"lower_chest_data":lower_chest_data};
            else if(data === "abdomen_data")            dataset = {"abdomen_data":abdomen_data};
            else if(data === "waist_data")              dataset = {"waist_data": waist_data};
            else if(data === "hip_data")                dataset = {"hip_data": hip_data};
            else if(data === "thigh_right_data")        dataset = {"thigh_right_data": thigh_right_data};
            else if(data === "thigh_left_data")         dataset = {"thigh_left_data": thigh_left_data};
            else if(data === "calf_right_data")         dataset = {"calf_right_data": calf_right_data};
            else if(data === "calf_left_data")          dataset = {"calf_left_data": calf_left_data};
            else if(data === "arm_right_data")          dataset = {"arm_right_data": arm_right_data};
            else if(data === "arm_left_data")           dataset = {"arm_left_data": arm_left_data};
            else if(data === "arm_flexed_right_data")   dataset = {"arm_flexed_right_data": arm_flexed_right_data};
            else if(data === "arm_flexed_left_data")    dataset = {"arm_flexed_left_data": arm_flexed_left_data};
            else if(data === "forearm_right_data")      dataset = {"forearm_right_data": forearm_right_data};
            else if(data === "forearm_left_data")       dataset = {"forearm_left_data": forearm_left_data};
            else if(data === "neck_data")               dataset = {"neck_data": neck_data};
            else if(data === "shoulder_data")           dataset = {"shoulder_data": shoulder_data};

            var maxMinObj = this.getMaxYAxisVals(data);
            var max_y_val = maxMinObj.max_y_val;
            var min_y_val = maxMinObj.min_y_val;

            // Clear out all data since we're fiultering out datasets
            this.setState({
                all_data: false,
                current_dataset: data,
                upper_chest_data: [],
                lower_chest_data: [],
                abdomen_data: [],
                waist_data: [],
                hip_data: [],
                thigh_right_data: [],
                thigh_left_data: [],
                calf_right_data: [],
                calf_left_data: [],
                arm_right_data: [],
                arm_left_data: [],
                arm_flexed_right_data: [],
                arm_flexed_left_data: [],
                forearm_right_data: [],
                forearm_left_data: [],
                neck_data: [],
                shoulder_data: [],
                max_y_val: max_y_val,
                min_y_val: min_y_val
            }, function (){
                this.setState(dataset);
            })
        }
    };

    getAllTooltip () {
        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "33%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend1_title }: {this.state.crossHairX} inches </span>
                        <span style={{display: "block",fontSize:16}}>{ legend2_title }: {this.state.crossHairY1} inches </span>
                        <span style={{display: "block",fontSize:16}}>{ legend3_title }: {this.state.crossHairY2} inches </span>
                        <span style={{display: "block",fontSize:16}}>{ legend4_title }: {this.state.crossHairY3} inches </span>
                        <span style={{display: "block",fontSize:16}}>{ legend5_title }: {this.state.crossHairY4} inches </span>
                        <span style={{display: "block",fontSize:16}}>{ legend6_title }: {this.state.crossHairY5} inches </span>
                    </span>

                    <span style={{display:"inline-block", width: "33%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend7_title }: {this.state.crossHairY6} inches </span>
                        <span style={{display: "block",fontSize:16}}>{ legend8_title }: {this.state.crossHairY7} inches </span>
                        <span style={{display: "block",fontSize:16}}>{ legend9_title }: {this.state.crossHairY8} inches </span>
                        <span style={{display: "block",fontSize:16}}>{ legend10_title }: {this.state.crossHairY9} inches </span>
                        <span style={{display: "block",fontSize:16}}>{ legend11_title }: {this.state.crossHairY10} inches </span>
                        <span style={{display: "block",fontSize:16}}>{ legend12_title }: {this.state.crossHairY11} inches </span>
                    </span>
                    <span style={{display:"inline-block", width: "33%", verticalAlign: "top"}}>

                        <span style={{display: "block",fontSize:16}}>{ legend13_title }: {this.state.crossHairY12} inches </span>
                        <span style={{display: "block",fontSize:16}}>{ legend14_title }: {this.state.crossHairY13} inches </span>
                        <span style={{display: "block",fontSize:16}}>{ legend15_title }: {this.state.crossHairY14} inches </span>
                        <span style={{display: "block",fontSize:16}}>{ legend16_title }: {this.state.crossHairY15} inches </span>
                        <span style={{display: "block",fontSize:16}}>{ legend17_title }: {this.state.crossHairY16} inches </span>

                    </span>
                </span>
    }

    // Show only 1 value in the tooltip hover //
    getSingleTooltip () {
        var dataset = this.state.current_dataset;
        var legend;
        var crosshair;
        if(dataset == "upper_chest_data") {
            legend    = legend1_title;
            crosshair = this.state.crossHairX;
        } else if(dataset == "lower_chest_data") {
            legend    = legend2_title;
            crosshair = this.state.crossHairY1;
        } else if(dataset == "abdomen_data") {
            legend    = legend3_title;
            crosshair = this.state.crossHairY2;
        } else if(dataset == "waist_data") {
            legend    = legend4_title;
            crosshair = this.state.crossHairY3;
        } else if(dataset == "hip_data") {
            legend    = legend5_title;
            crosshair = this.state.crossHairY4;
        } else if(dataset == "thigh_right_data") {
            legend    = legend6_title;
            crosshair = this.state.crossHairY5;
        } else if(dataset == "thigh_left_data") {
            legend    = legend7_title;
            crosshair = this.state.crossHairY6;
        } else if(dataset == "calf_right_data") {
            legend    = legend8_title;
            crosshair = this.state.crossHairY7;
        } else if(dataset == "calf_left_data") {
            legend    = legend9_title;
            crosshair = this.state.crossHairY8;
        } else if(dataset == "arm_right_data") {
            legend    = legend10_title;
            crosshair = this.state.crossHairY9;
        } else if(dataset == "arm_left_data") {
            legend    = legend11_title;
            crosshair = this.state.crossHairY10;
        } else if(dataset == "arm_flexed_right_data") {
            legend    = legend12_title;
            crosshair = this.state.crossHairY11;
        } else if(dataset == "arm_flexed_left_data") {
            legend    = legend13_title;
            crosshair = this.state.crossHairY12;
        } else if(dataset == "forearm_right_data") {
            legend    = legend14_title;
            crosshair = this.state.crossHairY13;
        } else if(dataset == "forearm_left_data") {
            legend    = legend15_title;
            crosshair = this.state.crossHairY14;
        } else if(dataset == "neck_data") {
            legend    = legend16_title;
            crosshair = this.state.crossHairY15;
        } else if(dataset == "shoulder_data") {
            legend    = legend17_title;
            crosshair = this.state.crossHairY16;
        }

        return <span>
                    <span style={{display:"inline-block", verticalAlign:"top", width: "100%"}}>
                        <span style={{display: "block",fontSize:16}}>{ legend }: { crosshair } inches</span>
                    </span>
                </span>
    }

    render() {
        var title     = this.state.title;
        var max_y_val = this.state.max_y_val;
        var min_y_val = this.state.min_y_val;
        var all_data  = this.state.all_data;
        var report_data  = this.state.report_data;
        var no_data_text;
        if(report_data === 0)  no_data_text  = <div style={{position:"relative", top: 75, padding: 15, fontSize:18}}>There is no assessment data.</div>


        var tooltip;
        var tooltip_width = 220;
        if(all_data) {
            tooltip_width = 550;
            tooltip       = this.getAllTooltip();
        } else {
            tooltip       = this.getSingleTooltip();
        }

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                <div className="iconAddExercise35pxVertSpacer"></div>
                <span style={{position:"relative", left:-10}}>
                        <div style={{fontSize:22, textAlign:"center"}}>
                            <FontAwesomeIcon icon="ruler" style={{fontSize: '1.4em', paddingRight: 8 }}/>
                            <span style={{position:"relative", top:-4}}>
                                { title }
                                { no_data_text }
                            </span>
                        </div>
                        <span style={{display:"inline-block",width:"100%", border:"0px solid #000"}}>

                                <FlexibleWidthXYPlot height       = {200}
                                                     xType        = "ordinal"
                                                     yDomain      = {[min_y_val, max_y_val]}
                                                     onMouseLeave = {this.onMouseLeavePreWorkout}
                                                     onMouseDown  = {() => {
                                                         //this.setState({showModalProgressDetail: true})
                                                        /*if (heldValue) {
                                                          this.setState({heldValue: false});
                                                          return;
                                                        }*/
                                                        //this.setState({heldValue: crosshairValues});
                                                      }}
                                                     >
                                  <VerticalGridLines />
                                  <HorizontalGridLines />

                                  <XAxis title="" {...axisProps}
                                         tickFormat={String}/>

                                  <YAxis title="Inches" {...axisProps}
                                         //tickValues={[0,10,20,30,40,50,260]}
                                         tickFormat={String} />

                                  <LineMarkSeries data={this.state.upper_chest_data}           size={2.5} color={upper_chest_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.lower_chest_data}          size={2.5} color={lower_chest_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.abdomen_data}        size={2.5} color={abdomen_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.waist_data}   size={2.5} color={waist_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.hip_data}        size={2.5} color={hip_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.thigh_right_data}      size={2.5} color={thigh_right_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.thigh_left_data}              size={2.5} color={thigh_left_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.calf_right_data}     size={2.5} color={calf_right_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.calf_left_data}             size={2.5} color={calf_left_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.arm_right_data}               size={2.5} color={arm_right_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.arm_left_data}            size={2.5} color={arm_left_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.arm_flexed_right_data}            size={2.5} color={arm_flexed_right_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.arm_flexed_left_data}            size={2.5} color={arm_flexed_left_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.forearm_right_data}            size={2.5} color={forearm_right_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.forearm_left_data}            size={2.5} color={forearm_left_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.neck_data}            size={2.5} color={neck_color} onNearestX={this.onNearestXPreWorkout}/>
                                  <LineMarkSeries data={this.state.shoulder_data}            size={2.5} color={shoulder_color} onNearestX={this.onNearestXPreWorkout}/>

                                  <Crosshair values={this.state.crosshairPreValues} >
                                      <div style={{float: "left", background: 'black', borderRadius: 5, width: tooltip_width, maxWidth: tooltip_width, borderRadius:5, padding: 10, zIndex: 1000}}>
                                          <span style={{display:"inline-block", width:"100%", fontSize:18, textAlign:"center"}}>{ title }</span>
                                             <br/>
                                             { tooltip }
                                      </div>
                                  </Crosshair>

                                </FlexibleWidthXYPlot>
                                { /**********  LEGEND  ***********/ }
                                <div style={{float: "left",  zIndex: 10}}>
                                    <DiscreteColorLegend items={GIRTH_LEGEND}
                                                         orientation='horizontal'
                                                         onItemClick={this.handleLegendClick}
                                                         style={{display: "inline-block", position:"relative", width:900, top:-7, left:35}}/>
                                     <DiscreteColorLegend items={GIRTH_LEGEND2}
                                                          orientation='horizontal'
                                                          onItemClick={this.handleLegendClick}
                                                          style={{display: "inline-block", position:"relative", width:900, top:-7, left:35}}/>
                                </div>
                        </span>
                 </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/report/AssessGirth.js